import React from 'react'
import Script from 'next/script'

function GoogleAnalytics() {
  if (process.env.NODE_ENV !== 'production') {
    return null
  }

  return (
    <>
      <Script async src="https://www.googletagmanager.com/gtag/js?id=UA-2610411-14" />
      <Script id="google-analytics">
        {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'UA-2610411-14');
            `}
      </Script>
    </>
  )
}

export default GoogleAnalytics
